import lodashCapitalize from 'lodash/capitalize';
import snakeCase from 'lodash/snakeCase';
import trim from 'lodash/trim';

export default function humanize(str: string) {
  return lodashCapitalize(trim(snakeCase(str).replace(/_id$/, '').replace(/_/g, ' '))) || '';
}

export const capitalize = (str: string | undefined) => {
  return str
    ? str
        .toLocaleLowerCase()
        .split(' ')
        .map((word) => lodashCapitalize(word))
        .join(' ')
    : '';
};
